/* global FormData */
(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name utils.fileuploader.factory:Fileupload
   *
   * @description
   *
   */
  angular
    .module('vcdms.vcfile')
    .factory('Fileupload', Fileupload);

  Fileupload.$inject = ['$http', '$log', 'Rlog'];

  function Fileupload($http, $log, Rlog) {
    let FileuploadBase = {};
    FileuploadBase.uploadFileToUrl = function (file, filecat, consultid, clientid, examid, method) {
      let fd = new FormData();

      // TODO: tweak backend to accept patientfname or look it up by itself
      fd.append('file', file);
      fd.append('filecat', filecat);
      fd.append('consultid', consultid);
      fd.append('patientid', clientid);
      fd.append('clientid', clientid);
      fd.append('examid', examid);
      fd.append('method', method);
      $log.debug('Uploading using method: ', method);
      Rlog.debug('vcdms.file', 'fileupload-factory', 'Uploading using method: ' + method, {method: method});

      return $http.post('/routes/files/upload', fd, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      });
    };
    return FileuploadBase;
  }
}());
